module.exports = __webpack_public_path__ + "img/DesenrolamientoHuella.69b9cb58.png";